<template>
  <span>
    <div class="section center">
      <div class="titulo-video">
        Cartas de amor e despedida - Como a pandemia da Covid-19 afeta a
        população encarcerada
      </div>
      <div class="video-player">
        <iframe
          width="680"
          height="390"
          src="https://www.youtube.com/embed/RRHEOF1nOVE"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
    <div class="section center">
      <div class="container-domino">
        <div
          data-aos="zoom-in-right"
          class="domino"
          v-for="(domino, index) in dominos"
          :key="index"
          :data-aos-delay="(index + 1) * 50"
          data-aos-duration="1000"
        >
          <div class="domino-inner" @click="abrirPopUp(index)">
            <div class="domino-front" @click="abrirPopUp(index)">
              <img src="@/assets/images/stj.png" />
              <div class="recurso">{{ domino.poder }}</div>
              <div class="nome">
                {{ domino.numero }}<br />
                <div class="espaco"></div>
                NOME: {{ domino.nome }}
              </div>
            </div>
            <div class="domino-back" @click="abrirPopUp(index)">
              <img src="@/assets/images/stj.png" />
              <div class="text">Clique para conhecer o caso</div>
            </div>
          </div>
        </div>
      </div>
      <div class="click-lelas mt-4">
        <i class="bi bi-hand-index mr-3"></i>
        Clique nas capas de processo para conhecer o caso.
      </div>
      <p class="text" style="margin-top: 14px;">Os relatos de casos foram extraídos da pesquisa  “Gestão da morte nas prisões e a pandemia da Covid-19”, cujo relatório pode ser acessado na íntegra <a href="https://drive.google.com/file/d/1QKiLAMKHhnQAga50sgO2BolSJKZQsRIH/view?usp=drivesdk " target="_blank">aqui.</a></p>
      <div class="rodape mt-5">
        <!-- <i>*Os nomes das vítimas foram alterados.</i> -->
      </div>
      <PopUpDomino
        v-if="isShowed"
        :is-showed="isShowed"
        :index="actualDomino"
        @close="fecharPopUp"
      />
    </div>
  </span>
</template>

<script>
import PopUpDomino from "@/components/PopUpDomino.vue";
import { dominos } from "@/consts/domino.js";
export default {
  data() {
    return {
      dominos,
      isShowed: false,
      actualDomino: dominos[0],
    };
  },
  components: {
    PopUpDomino,
  },
  methods: {
    abrirPopUp(item) {
      this.actualDomino = item;
      this.isShowed = true;
    },
    fecharPopUp() {
      this.isShowed = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  height: 100vh;
}

.click-lelas {
  font-family: Roboto Condensed;
  font-size: 14px;
  line-height: 16px;
  color: #626262;
}

.titulo-video {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 300;
  font-size: 1.8rem;
  line-height: 1.7rem;
  color: #d01c1f;
  margin-bottom: 30px;
  width: 680px;
  text-align: center;
}

.rodape {
  font-family: Roboto Condensed;
  font-size: 14px;
  line-height: 16px;
  color: #626262;
}

.container-domino {
  min-height: fit-content;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: -100px;
  row-gap: 20px;
  column-gap: 30px;
  width: 520px;
  .domino {
    width: 145px;
    height: 220px;
    cursor: pointer;
    perspective: 2500px;

    .domino-back {
      border-radius: 10px;
      transform: rotateY(180deg);
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      row-gap: 20px;
      padding: 5px 8px;
      filter: drop-shadow(4px 4px 0px #58556d);
      position: relative;

      .text {
        font-family: Roboto Condensed;
        font-style: normal;
        font-weight: normal;
        font-size: 11px;
        line-height: 11px;
        text-align: center;
        text-transform: uppercase;
        color: #0a4066;
      }
    }

    .domino-front {
      border-radius: 10px;
      background-color: #beb8e9;
      display: flex;
      align-items: center;
      // justify-content: space-between;
      flex-direction: column;

      padding: 5px 8px;
      filter: drop-shadow(4px 4px 0px #58556d);
      img {
        width: 40px;
      }

      .recurso {
        margin-top: 10px;
        text-transform: uppercase;
        font-size: 12px;
        line-height: 14px;
        color: #072c44;
        border-radius: 6px;
        padding: 2px 2px;
      }

      .nome {
        font-family: Roboto Condensed;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
        text-transform: uppercase;
        color: #072c44;
        border: 1px solid #072c44;
        border-radius: 5px;
        position: absolute;
        bottom: 10px;
        margin: 0 10px;
        padding: 4px 4px;
      }

      .espaco {
        height: 10px;
      }
    }
  }
}

.domino-back {
  img {
    position: absolute;
    width: 40px;
    top: 7px;
  }
}

.domino-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

.domino:hover .domino-inner {
  transform: rotateY(180deg);
}

.domino-front,
.domino-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
}

@media screen and (max-width: 480px) {
  .section {
    height: 950px;
  }
  .container-domino {
    width: 100%;
    row-gap: 10px;
    column-gap: 10px;

    .domino {
      width: 120px;
      height: 210px;

      .domino-front {
        .recurso {
          font-size: 11px;
        }
        .nome {
          font-size: 10px;
        }
      }
    }
  }

  .titulo-video {
    width: 100%;
    font-size: 1.2rem;
    line-height: 1;
    margin-bottom: 15px;
  }

  .video-player {
    iframe {
      width: 100%;
    }
  }
}
</style>